import { env, url } from '@didi/utils'
import bridge from './bridge'
import { weixinReady } from '@/common/ts/weixin'

const shareConfig = {
  url: '/driver-biz/driver-medical-insurance/index.html?entry=home',
  title: '滴滴司机专属医疗及意外保障计划',
  content: '您守护他人安全，我守护您的健康',
  icon: 'https://dpubstatic.udache.com/static/dpubimg/cd93b633-9e17-4563-bf6a-aab36f3d1d04.png'
}
const onlineDomain = 'page.udache.com'
const testDomain = 'h5test.intra.xiaojukeji.com'

if (document.domain === onlineDomain) {
  shareConfig.url = 'https://' + onlineDomain + shareConfig.url
} else {
  shareConfig.url = 'http://' + testDomain + shareConfig.url
}

export function initShare(params: {
  companyId: number,
  areaId: number
}): void {
  const urlParams: Record<string, unknown> = {
    company_id: params.companyId,
    area_id: params.areaId
  }
  if (!urlParams.insurance_id) delete urlParams.insurance_id
  if (!urlParams.company_id) delete urlParams.company_id
  if (!urlParams.area_id) delete urlParams.area_id
  shareConfig.url = url.concatUrl(shareConfig.url, urlParams)
  if (env.isWechat) {
    initShareInWx()
  }
  if (env.isDriver || env.rainbow) {
    initShareInApp()
  }
}

async function initShareInWx() {
  await weixinReady()
  // eslint-disable-next-line
  // @ts-ignore
  const WX = window.wx

  WX.ready(function() {
    WX.checkJsApi({
      jsApiList: ['updateAppMessageShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
      success: function(res) {
        console.log(res)
      }
    })
    WX.updateAppMessageShareData({
      title: shareConfig.title, // 分享标题
      desc: shareConfig.content, // 分享描述
      link: shareConfig.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareConfig.icon // 分享图标
    })
    WX.onMenuShareAppMessage({
      title: shareConfig.title, // 分享标题
      desc: shareConfig.content, // 分享描述
      link: shareConfig.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareConfig.icon
    })
  })
  WX.error(function(res) {
    console.log('失败:', res)
  })
}

function initShareInApp() {
  bridge.initEntrance({
    buttons: [
      {
        type: 'shareWeixinAppmsg', // 微信好友信息
        data: shareConfig
      }, {
        type: 'shareWeixinTimeline', // 朋友圈
        data: shareConfig
      }, {
        type: env.rainbow ? 'shareDriverTribeIM' : 'shareDidiTribe', // 司机部落
        data: shareConfig
      }
    ]
  })
}

export function invokeEntrance(): void {
  bridge.invokeEntrance({}, function() { /* empty fn */ })
}
